import { type IFrontHeaderCompactLayoutProps } from '@framework/theme/front/FrontHeaderCompactLayout.tsx';
import { ContentLayoutWrapper } from '@framework/ui/components/layout/ContentLayoutWrapper.tsx';
import { FullscreenHeaderLogo } from '@framework/ui/components/layout/fullscreen/FullscreenHeaderLogo.tsx';
import { FullscreenHeaderRow } from '@framework/ui/components/layout/fullscreen/FullscreenHeaderRow.tsx';
import { useTheme } from 'styled-components';
import {
  HeaderMenuBackgroundColor,
  MenuBar,
  StyledHeader,
} from './FrontHeaderTopLayout.tsx';
import { frontLogo } from './header/FrontHeaderLogo.tsx';

/**
 * Header del layout fullscreen: solo la fascia del menu, con logo e
 * menu destro inclusi (come la versione mobile di FrontHeaderTopLayout).
 */
export function FrontHeaderCompactLayout(
  props: IFrontHeaderCompactLayoutProps,
) {
  const { main, right, onLogoClick, isMobile } = props;
  const theme = useTheme();

  // Gestione interna della larghezza del'header
  const headerBoxed = theme.boxedFrontofficeHeaderFooterLayoutFlag ?? false;

  return (
    <StyledHeader>
      <HeaderMenuBackgroundColor>
        <ContentLayoutWrapper boxed={headerBoxed}>
          <MenuBar>
            <FullscreenHeaderRow
              logo={
                <FullscreenHeaderLogo
                  src={frontLogo.url}
                  alt={theme.logoAltText}
                  onClick={onLogoClick}
                />
              }
              main={main}
              right={right}
              isMobile={isMobile}
            />
          </MenuBar>
        </ContentLayoutWrapper>
      </HeaderMenuBackgroundColor>
    </StyledHeader>
  );
}
